import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Box,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
} from "@mui/material"
import { INVOICE_TEXT_MAX_LENGTH } from "../utils/invoiceUtils"

const InvoiceNotes = ({ invoiceData, setInvoiceData, issued = false }) => {
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (invoiceData.notes && invoiceData.notes.trim() !== "") {
      setExpanded(true)
    }
  }, [invoiceData.notes])

  const handleCheckboxChange = event => {
    setExpanded(event.target.checked)
  }

  const handleNotesChange = value => {
    setInvoiceData(prev => ({
      ...prev,
      notes: value,
    }))
  }

  const notesLength = (invoiceData.notes || "").length

  if (issued && (!invoiceData.notes || invoiceData.notes.trim() === "")) {
    return null
  }

  return (
    <Paper elevation={0} sx={{ px: 3, pt: issued ? 2 : 0, mb: 2 }}>
      {issued && (
        <Typography variant="h6" sx={{ mb: 1 }}>
          {i18n.t("invoices.notes")}
        </Typography>
      )}
      <Accordion expanded={expanded} sx={{ boxShadow: "none", mb: 0 }}>
        {!issued && (
          <AccordionSummary
            expandIcon={null}
            aria-controls="invoice-notes-content"
            id="invoice-notes-header"
            sx={{
              background: "transparent",
              p: 0,
              cursor: "default !important",
              minHeight: 0,
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
              },
            }}
          >
            <FormControlLabel
              sx={{ mb: 0 }}
              control={
                <Checkbox
                  checked={expanded}
                  onChange={handleCheckboxChange}
                  name="addNote"
                  color="primary"
                  size="small"
                  sx={{ cursor: "pointer !important" }}
                  onClick={e => e.stopPropagation()}
                />
              }
              label={
                <Typography variant="body1" sx={{ textTransform: "none" }}>
                  {i18n.t("invoices.addTextToDocument")}
                </Typography>
              }
              onClick={e => e.stopPropagation()}
            />
          </AccordionSummary>
        )}
        <AccordionDetails sx={{ background: "transparent", px: 0, pb: 3 }}>
          {issued ? (
            <Box
              sx={{ maxHeight: 220, overflowY: "auto", overflowX: "hidden" }}
            >
              <div style={{ whiteSpace: "pre-wrap" }}>
                {invoiceData.notes || ""}
              </div>
            </Box>
          ) : (
            <>
              <textarea
                value={invoiceData.notes || ""}
                onChange={e => handleNotesChange(e.target.value)}
                maxLength={INVOICE_TEXT_MAX_LENGTH}
                style={{
                  width: "100%",
                  minHeight: 220,
                  resize: "vertical",
                  padding: 8,
                  boxSizing: "border-box",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  textAlign: "right",
                  color:
                    notesLength >= INVOICE_TEXT_MAX_LENGTH
                      ? "error.main"
                      : "text.secondary",
                }}
              >
                {`${notesLength}/${INVOICE_TEXT_MAX_LENGTH}`}
              </Typography>
            </>
          )}
        </AccordionDetails>
      </Accordion>
    </Paper>
  )
}

export default InvoiceNotes

InvoiceNotes.propTypes = {
  invoiceData: PropTypes.shape({
    notes: PropTypes.string,
  }).isRequired,
  setInvoiceData: PropTypes.func.isRequired,
  issued: PropTypes.bool,
}
